var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import * as Option from "fp-ts/lib/Option";
import { content, Id } from "core/utils";
import { ArrowLink } from "core/components";
import { mq } from "core/styles/snippets";
function isCompatible(video) {
    return video.program !== null;
}
export var block = function (data) {
    if (!isCompatible(data))
        return Option.none;
    return Option.some({
        key: "programLink_".concat(data.uuid),
        View: function () { return (React.createElement(ArrowContainer, null,
            React.createElement(ArrowLink, { url: data.program.slug, title: "".concat(content.goToProgramPrefix, " ").concat(data.program.title), variant: "secondary", "data-action": Id.action.videoProgramLink }))); },
    });
};
var ArrowContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  max-width: 80rem;\n  margin: 0 auto;\n  padding: 0.5rem 0 2rem;\n\n  ", " {\n    padding: 1rem 0 2rem;\n  }\n\n  ", " {\n    padding: 1.3725rem 5rem 3rem;\n  }\n\n  ", " {\n    padding: 1.3725rem 5rem 3.5rem;\n  }\n\n  ", " {\n    padding: 1.3725rem 5rem 5rem;\n  }\n\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  max-width: 80rem;\n  margin: 0 auto;\n  padding: 0.5rem 0 2rem;\n\n  ", " {\n    padding: 1rem 0 2rem;\n  }\n\n  ", " {\n    padding: 1.3725rem 5rem 3rem;\n  }\n\n  ", " {\n    padding: 1.3725rem 5rem 3.5rem;\n  }\n\n  ", " {\n    padding: 1.3725rem 5rem 5rem;\n  }\n\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n"])), mq.minWidth("20rem"), mq.minWidth("64rem"), mq.minWidth("90rem"), mq.minWidth("120rem"));
var templateObject_1;
